import Goal from "@ui-kit/icons/target-accent600.svg";
import Clock from "@ui-kit/icons/clock-accent600.svg";
import HeartOutline from "@ui-kit/icons/heart-accent600.svg";
import Dollar from "@ui-kit/icons/dollar-accent600.svg";
import Hug from "@ui-kit/icons/hug-accent600.svg";

export const RIGHT_PRODUCTS = [
  {
    title: "Saving time",
    description: "Forget about haphazardly selecting tags - everything has already been done for you",
    ico: Clock,
    alt: "time",
  },
  {
    title: "Increase sales",
    description: "The right keywords mean more visibility, more downloads, higher income",
    ico: Dollar,
    alt: "dollar",
  },
  {
    title: "No language barrier",
    description: "Even with basic English, you will understand which words will bring profit",
    ico: HeartOutline,
    alt: "heart",
  },
  {
    title: "Intuitively clear",
    description: "Even a beginner can handle the interface - keywording has become easier than ever",
    ico: Goal,
    alt: "goal",
  },
  {
    title: "Dictionary expansion",
    description: "Find new selling keywords that you didn't know about before",
    ico: Hug,
    alt: "hug",
  },
];
